import type { VideoModelConfig } from '../../types';

/** 可灵 3.0 Omni（多模态：参考视频 + 声音 + 保留原声） */
export const kling3_0Omni: VideoModelConfig = {
  id: '01KKJDY556DWXJJD60T92PA6AF',
  displayName: '可灵 3.0 Omni',
  defaults: {
    ratio: '9:16',
    resolution: '720P',
    duration: 5,
    sound: 'on',
    keepOriginalSound: true,
  },
  ratioOptions: [
    { label: '1:1', value: '1:1' },
    { label: '9:16', value: '9:16' },
    { label: '16:9', value: '16:9' },
  ],
  resolutionOptions: [
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
    { label: '4K', value: '4K' },
  ],
  duration: { mode: 'range', min: 3, max: 15, step: 1, default: 5 },
  capabilities: {
    refVideo: true,
    sound: true,
    keepOriginalSound: true,
    multiModalReference: true,
  },
  limits: {
    maxRefImages: 7,
    maxRefVideos: 1,
    // 参考视频上传约束（转写自 VideoSelectModal 原硬编码）：格式 mp4/mov、单文件 ≤50MB、时长 [3,15]s
    refVideoConstraints: {
      formats: ['mp4', 'mov'],
      maxFileSizeMB: 50,
      duration: { min: 3, max: 15 },
      hintKey: 'imageCreation.videoUploadHint',
    },
    // 提交前参考视频约束（汇总层校验）：尺寸 720~2160、合计时长 ≤10s
    // ⚠️ 与 refVideoConstraints（上传时单文件层）是「两层独立校验」：上传时查单段 [3,15]s，
    // 提交前只查「尺寸 + 合计时长」、不查单段时长，两套阈值各自定义、不对齐。
    refVideoSubmitConstraints: {
      dimension: { min: 720, max: 2160 },
      duration: { totalMax: 10 },
      // 提交前校验失败文案：保留原硬编码中文（行为等价、用户无感知），新造 i18n key 承载
      errorKeys: {
        width: 'imageCreation.klingOmniVideoDimension',
        height: 'imageCreation.klingOmniVideoDimension',
        totalDuration: 'imageCreation.klingOmniVideoTotalDuration',
      },
    },
  },
  /** 画布扩展（节点式业务专属字段，从画布 configs/kling-3.0-omni.ts 迁移） */
  canvas: {
    defaults: {
      audioSync: true,
    },
    toggles: {
      audioSync: true,
      keepOriginalSound: true,
    },
    capabilities: {
      refVideo: true,
      refAudio: false,
      atMentionTabs: ['全能参考', '图生视频', '视频编辑', '视频延长'],
    },
    limits: {
      validateRefImageSize: true,
      promptMaxLength: 2500,
      maxRefImages: 7,
      maxRefImagesWithRefVideo: 4,
      maxRefVideos: 1,
      maxRefAudios: 0,
      refImageConstraints: {
        formats: ['jpg', 'jpeg', 'png'],
        maxFileSizeMB: 20,
        dimension: { min: 300, max: 6000 },
        aspectRatio: { min: 0.4, max: 2.5 },
      },
      refVideoConstraints: {
        formats: ['mp4', 'mov'],
        maxFileSizeMB: 50,
        dimension: { min: 720, max: 2160 },
        duration: { min: 3, max: 15, totalMax: 15 },
      },
    },
  },
};
